let clarityFunc = () => {
    (window as any).clarity('consent');
}

export { clarityFunc }